import { Outlet } from "react-router-dom";

import BackofficeNiceModalProvider from "components/context/BackofficeNiceModalProvider";
import { ConstantBackofficeProvider } from "components/context/ConstantProvider";
import CustomProvider from "components/context/CustomProvider";
import Layout from "components/ui/molecules/Layout";
import myOfficeModelExtraData from "models/myoffice/myOfficeModelExtraData";
import myOfficeConfig from "./myOfficeConfig";

const MyOfficeLayout = () => {
  return (
    <ConstantBackofficeProvider>
      <CustomProvider modelExtraData={myOfficeModelExtraData}>
        <BackofficeNiceModalProvider>
          <Layout container config={myOfficeConfig}>
            <Outlet />
          </Layout>
        </BackofficeNiceModalProvider>
      </CustomProvider>
    </ConstantBackofficeProvider>
  );
};

export default MyOfficeLayout;
